import { attachDialog, closeDialog } from '../../util/dialog_helpers.js';
import { addPageAction } from '../../util/new_relic.js';
import { getUserPrefs, updatePrefs } from '../../util/user_prefs_util.js';

export async function shouldShowRemoveFamilyConfirmationDialog() {
  const userPrefs = await getUserPrefs();
  return !userPrefs.hideRemoveFamilyConfirmationModal;
}

const handleButtonClick = (checked: boolean) => {
  updatePrefs({ hideRemoveFamilyConfirmationModal: checked });
  closeDialog();
};

const attachEventHandlers = (dialog: HTMLElement, callback: () => void) => {
  const checkbox = dialog.querySelector('[data-id="remove-family-confirmation-checkbox"]') as HTMLInputElement;

  const cancelButton = dialog.querySelector('[data-id="remove-cancel-button"]');
  if (cancelButton) {
    cancelButton.addEventListener('click', () => {
      addPageAction('typekit.click.remove-family-dialog-cancel');
      handleButtonClick(checkbox.checked);
    }, { once: true });
  }

  const confirmButton = dialog.querySelector('[data-id="remove-confirm-button"]');
  if (confirmButton) {
    confirmButton.addEventListener('click', () => {
      handleButtonClick(checkbox.checked);
      callback();
    }, { once: true });
  }
};

/**
 * Show the Remove Family Confirmation dialog
 * Ensure the promise resolves when the dialog is closed or
 * if we don't need to show the dialog so that add to web project
 * dialog can be opened
 * @return {Promise<void>}
 */
export const showRemoveFamilyConfirmationDialog = async (header: string, description: string, callback: () => void) => {
  try {
    const { dialog, dialogPromise } = await attachDialog('remove_family_confirmation_dialog') as { dialog: HTMLElement, dialogPromise: Promise<void> };

    const dialogHeader = dialog.querySelector('.remove-family-confirmation-dialog__heading');
    if (dialogHeader) {
      dialogHeader.textContent = header;
    }

    const dialogDescription = dialog.querySelector('.remove-family-confirmation-dialog__body-text');
    if (dialogDescription) {
      dialogDescription.textContent = description;
    }

    attachEventHandlers(dialog, callback);

    return dialogPromise;
  } catch (error) {
    console.error('Error fetching dialog template:', error);
    throw error;
  }
};
